module.exports = __webpack_public_path__ + "img/spring_trip-20160416-22.f5ca314a.jpg";